/** OnboardingGuard — onboarding 路由访问控制
 *
 * 规则：
 * 1. 已完成 onboarding → 重定向到 /illuminate
 * 2. 要求登录的页面（问卷）→ 未登录重定向到 /login，带 returnTo
 * 3. 其他 onboarding 页面（value, pillars, preview, not-fit）可公开访问
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useSessionStore } from '../stores/session-store';
import { useIsDesktop } from '../hooks/useMediaQuery';

export function OnboardingGuard({
  children,
  requireAuth = false,
}: {
  children: React.ReactNode;
  requireAuth?: boolean;
}) {
  const isAuthenticated = useSessionStore(s => s.isAuthenticated);
  const onboardingCompleted = useSessionStore(s => s.onboardingCompleted);
  const isLoading = useSessionStore(s => s.isLoading);
  const location = useLocation();
  const isDesktop = useIsDesktop();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: 'var(--bg-primary)',
      }}>
        <div className="animate-breath" style={{
          width: 48, height: 1, background: 'var(--accent-primary)',
        }} />
      </div>
    );
  }

  // 已完成 onboarding → 直接进应用
  if (onboardingCompleted) {
    return <Navigate to="/illuminate" replace />;
  }

  // 需要登录但未登录 → 去登录页，记住回来路径
  if (requireAuth && !isAuthenticated) {
    return (
      <Navigate
        to={isDesktop ? '/landing' : '/login'}
        state={{ returnTo: location.pathname }}
        replace
      />
    );
  }

  return <>{children}</>;
}
